import { useTranslation } from "react-i18next";
import { useClockStore } from "../store/clockStore.js";

function fmtCountdown(seconds, t) {
  if (seconds === null) return "—";
  if (seconds <= 0) return t("next_check.any_moment");

  const d = Math.floor(seconds / 86400);
  const h = Math.floor((seconds % 86400) / 3600);
  const m = Math.floor((seconds % 3600) / 60);
  const s = seconds % 60;

  if (d > 0) return t("next_check.in_days", { d, h });
  if (h > 0) return t("next_check.in_hours", { h, m });
  if (m > 0) return t("next_check.in_minutes", { m, s });
  return t("next_check.in_seconds", { s });
}

/**
 * Live countdown to the next scheduled check.
 * Driven by the global clock in clockStore — no per-instance interval.
 */
export default function NextCheck({ lastCheckAt, intervalSeconds, className = "" }) {
  const { t } = useTranslation();
  const now = useClockStore((s) => s.now);

  if (!lastCheckAt || !intervalSeconds) {
    return <span className={className}>—</span>;
  }

  const nextMs = new Date(lastCheckAt).getTime() + intervalSeconds * 1000;
  const seconds = Math.round((nextMs - now) / 1000);
  const isOverdue = seconds <= 0;

  return (
    <span className={`tabular-nums${isOverdue ? " text-amber-500" : ""}${className ? ` ${className}` : ""}`}>
      {fmtCountdown(seconds, t)}
    </span>
  );
}
